import { Box, Container } from "@mui/material";
import React from "react";
import CustomText from "../../customComponents/customText";
import { translation } from "../../assets/translation";
import { language } from "../../assets/function";
import { Colors } from "../../assets/colors";
import CustomImage from "../../customComponents/customImage";
import CheckImg from "../../assets/images/checkfeaturemark.svg";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
let tableLeftWidth = 55;
let tableRightWidth = (100 - tableLeftWidth) / 3;
function Comparefeature() {
  let staticText = translation[language];
  let customImageWidth = 30;
  let navigate = useNavigate();

  // Define CardBox component to accept children properly

  return (
    <Box sx={styles.container}>
      <Container maxWidth="xl" sx={styles.containerStyle}>
        <Box
          onClick={() => {
            navigate("/pricing");
          }}
        >
          <CustomText
            desc={staticText.compareFeatures}
            fontFamily="Inter"
            colorvalue={Colors.menuListBgColor}
            style={{
              ...styles.andaihubTxt,
              fontSize: {
                xs: '15px',    // mobile
                sm: '20px',    // tablet
                md: '22px',    // small desktop
                lg: '24px',    // desktop
                xl: '24px'     // large screens
              },
              marginLeft: {
                xs: 1,
                sm: 1.5,
                md: 2,
                lg: 2,
                xl: 2
              },
              marginTop: {
                xs: 0,
                sm: 0.4,
                md: 0.5,
                lg: 0.5,
                xl: 0.5
              }
            }}
            h5
            fontWeight={600}
          />
        </Box>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }} // Delayed start for staggered effect
        >
          <Box sx={styles.compareFeature}>
            <Box sx={styles.headBox}>
              {staticText.compareFeatureHeader.map((item, index) => (
                <CustomText
                  key={item}
                  desc={item}
                  fontFamily="Inter"
                  colorvalue={Colors.menuListBgColor}
                  style={{
                    ...styles.headText,
                    justifyContent: index === 0 ? "flex-start" : "center",
                    width:
                      index === 0
                        ? `${tableLeftWidth}%`
                        : `${tableRightWidth}%`,
                    textAlign: index === 0 ? "left" : "center",
                    paddingLeft: index === 0 ? "0" : "8px",
                    paddingRight: index === 0 ? "0" : "8px",
                    wordBreak: "break-word",
                    fontSize: index ===0 ? {
                      xs: '22px',    // mobile
                      sm: '16px',    // tablet
                      md: '18px',    // small desktop
                      lg: '20px',    // desktop
                      xl: '20px'     // large screens
                    } : {
                      xs: '16px',    // mobile
                      sm: '20px',    // tablet
                      md: '22px',    // small desktop
                      lg: '24px',    // desktop
                      xl: '24px'     // large screens
                    }

                  }}
                  {...(index === 0 ? { title7: true } : { title1: true })}
                  fontWeight={index === 0 ? 700 : 400}
                />
              ))}
            </Box>
            <Box sx={{ width: "100%" }}>
              {staticText.compareFeatureBox.map((item) => (
                <Box
                  sx={{ 
                    ...styles.headBox, 
                    marginTop: {
                      xs: 2,    // 16px for mobile
                      sm: 3,    // 24px for tablet
                      md: 3.5,  // 28px for small desktop
                      lg: 4,    // 32px for desktop
                      xl: 4     // 32px for large screens
                    } 
                  }}
                  key={item.feature}
                >
                  <CustomText
                    key={item.feature}
                    desc={item.feature}
                    fontFamily="Inter"
                    colorvalue={Colors.andaihubTxt}
                    style={{
                      ...styles.headText,
                      width: `${tableLeftWidth}%`,
                      fontSize: {
                        xs: '14px',    // mobile
                        sm: '16px',    // tablet
                        md: '18px',    // small desktop
                        lg: '20px',    // desktop
                        xl: '20px'     // large screens
                      }
                    }}
                    h4
                    fontWeight={400}
                  />
                  {item.free ? (
                    <Box sx={styles.imageBox}>
                      <CustomImage
                        filename={CheckImg}
                        width={customImageWidth}
                        height={customImageWidth}
                        sx={styles.image}
                      />
                    </Box>
                  ) : (
                    <Box sx={styles.imageBox}></Box>
                  )}
                  {item.startups ? (
                    <Box sx={styles.imageBox}>
                      <CustomImage
                        filename={CheckImg}
                        width={customImageWidth}
                        height={customImageWidth}
                        sx={styles.image}
                      />
                    </Box>
                  ) : (
                    <Box sx={styles.imageBox}></Box>
                  )}
                  {item.enterprise ? (
                    <Box sx={styles.imageBox}>
                      <CustomImage
                        filename={CheckImg}
                        width={customImageWidth}
                        height={customImageWidth}
                        sx={styles.image}
                      />
                    </Box>
                  ) : (
                    <Box sx={styles.imageBox}></Box>
                  )}
                </Box>
              ))}
            </Box>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
}

const styles = {
  compareFeature: {
    paddingTop: {
      xs: 8,  // 64px for mobile
      sm: 12, // 96px for tablet
      md: 14, // 112px for small desktop
      lg: 16, // 128px for desktop
      xl: 18, // 144px for large screens
    },
    paddingLeft: {
      xs: "4%",
      sm: "3%",
      md: "2%",
      lg: "1%",
      xl: "8%",
    },
    paddingRight: {
      xs: "4%",
      sm: "3%",
      md: "2%",
      lg: "1%",
      xl: "8%",
    },
  },
  imageBox: {
    width: `${tableRightWidth}%`,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  headBox: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },
  headText: {
    display: "flex",
    minWidth: 0,
  },
  andaihubTxt: {
    textAlign: "center",
    "&:hover": {
      color: Colors.compareFeatureLight, // Replace with your desired hover color
    },
    cursor: "pointer",
  },
  itemBox: {
    display: "flex",
    marginTop: 1,
    alignItems: "center",
    alignContent: "center",
  },
  btnTextStyle: {
    textTransform: "none",
  },
  containerStyle: {
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.white,
    paddingTop: {
      xs: 10, // 80px for mobile
      sm: 15, // 120px for tablet
      md: 18, // 144px for small desktop
      lg: 20, // 160px for desktop
      xl: 20, // 160px for large screens
    },
    // paddingBottom: 20,
  },
  btnStyle: {
    marginTop: 1.5,
    borderRadius: 1,

    paddingTop: 1,
    paddingBottom: 1,
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    justifyItems: "center",
    backgroundColor: Colors.red,
    display: "flex", // Make sure the button is using flexbox
  },
  cardSubBoxStyle: {
    justifyContent: "center",
    alignItems: "center",
  },
};

export default Comparefeature;
